import React from 'react';
import { MailIcon, GlobeIcon, InstagramIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0a0a0a] border-t border-purple-500/20 py-12 px-4" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        {/* Brand */}
        <h3 className="text-2xl md:text-3xl font-black text-white uppercase tracking-wide mb-3" data-id="element-72">
          ✨ LUXURY BROW EXTENSIONS™
        </h3>
        <p className="text-gray-400 text-base md:text-lg mb-2" data-id="element-73">
          El programa N°1 de extensión de cejas pelo por pelo y negocio beauty
          en Argentina.
        </p>
        <p className="text-[#FC9DFF] italic text-sm md:text-base font-medium mb-8" data-id="element-74">
          Empezá hoy y llevá tus servicios al siguiente nivel.
        </p>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8 text-sm md:text-base" data-id="element-75">
          <a href="mailto:luxurybrowes@gmail.com" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-76">
            <MailIcon className="w-4 h-4" data-id="element-77" />
            luxurybrowes@gmail.com
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-78">•</span>
          <a href="https://www.instagram.com/luxurybrowes/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-79">
            <InstagramIcon className="w-4 h-4" data-id="element-80" />
            @luxurybrowes
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-81">•</span>
          <a href="https://dominandoshopify.brendamelisah.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-82">
            luxurybrowes.online
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-6" data-id="element-83">
          <p className="text-gray-500 text-sm mb-2" data-id="element-84">
            © Luxury Brow Extensions™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-xs" data-id="element-85">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}